import { defineComponent, ref, watch } from 'vue'

import { MsBell, MsClose } from '@sunrise/icons'
import { clickAnywhereHandler } from '@sunrise/shared'

export default defineComponent({
    name: 'MsNudge',
    components: {
        MsClose,
        MsBell,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['closeNudge'],
    setup(props, { emit }) {
        const nudge = ref<null | HTMLElement>(null)
        let anywhereId: number

        function closeNudge() {
            emit('closeNudge')
            clickAnywhereHandler.unsubscribe(anywhereId)
        }

        watch(
            () => props.visible,
            (newVisible) => {
                if (newVisible) {
                    setTimeout(() => {
                        if (nudge.value) {
                            anywhereId = clickAnywhereHandler.subscribe(nudge.value, closeNudge)
                        }
                    }, 1)
                }
            },
        )

        return {
            nudge,
            closeNudge,
        }
    },
})
